export class JobProgressStepDatabaseCreationData {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "dbIdentifier",
            "baseName": "dbIdentifier",
            "type": "string",
            "format": ""
        },
        {
            "name": "isCluster",
            "baseName": "isCluster",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "engineVersion",
            "baseName": "engineVersion",
            "type": "string",
            "format": ""
        },
        {
            "name": "availabilityZone",
            "baseName": "availabilityZone",
            "type": "string",
            "format": ""
        },
        {
            "name": "vpcId",
            "baseName": "vpcId",
            "type": "string",
            "format": ""
        },
        {
            "name": "engine",
            "baseName": "engine",
            "type": "string",
            "format": ""
        },
        {
            "name": "instanceClass",
            "baseName": "instanceClass",
            "type": "string",
            "format": ""
        },
        {
            "name": "subnetGroupName",
            "baseName": "subnetGroupName",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountId",
            "baseName": "accountId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountName",
            "baseName": "accountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "region",
            "baseName": "region",
            "type": "string",
            "format": ""
        },
        {
            "name": "consoleUrl",
            "baseName": "consoleUrl",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return JobProgressStepDatabaseCreationData.attributeTypeMap;
    }
    constructor() {
    }
}
